import { CLEAR_ALL, LOGOUT } from '../../../store/Types';

export const ALL_MATRICULAS = 'ALL_MATRICULAS';
export const ACTIVO_MATRICULAS = 'ACTIVO_MATRICULAS';
export const LOADING_ALL_MATRICULAS = 'LOADING_ALL_MATRICULAS';
export const PARAMS_MATRICULAS = 'PARAMS_MATRICULAS';

const initialState = {
  all: [],
  loadingAll: false,
  activo: null,
  params: {},
};

export const matriculasReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_MATRICULAS:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case ACTIVO_MATRICULAS:
      return {
        ...state,
        activo: action.payload,
      };
    case LOADING_ALL_MATRICULAS:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case PARAMS_MATRICULAS:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
